// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"AN-z","carousel":"BN-z"};